import "./facilities.css";
import facility1 from "../../assets/images/facility1.jpg";
import facility2 from "../../assets/images/facility2.jpg";
import { useTranslation } from "../../shared/LanguageContext";

const Facilities = () => {
    const { t } = useTranslation();
    return (
        <div className="facilities-container">
            <h3 id="facils">{t("facilities_title")}</h3>

            <div className="facilities-wrapper">
                <div className="facility-details">
                    <div className="facility-detail-head">
                        <h6>{t("facilities_head")}</h6>
                    </div>
                    <div className="facility-detail-body">
                        <p>{t("facilities_desc")}</p>
                    </div>
                </div>

                <div className="facility-images">
                    <img className="facility1" src={facility1} alt="учреждение" />
                    <img className="facility2" src={facility2} alt="учреждение" />
                </div>
            </div>
        </div>
    );
};

export default Facilities;
